"use strict";
// =============== SHARED COMPONENT TYPES ===============
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMovieRating = exports.getMovieYear = exports.getMoviePosterUrl = exports.ComponentTheme = void 0;
// =============== SHARED COMPONENT UTILITIES ===============
exports.ComponentTheme = {
    colors: {
        primary: '#007AFF',
        secondary: '#F2F2F7',
        text: {
            primary: '#000000',
            secondary: '#666666',
            inverse: '#FFFFFF',
        },
        border: '#E1E1E1',
        background: '#FFFFFF',
        placeholder: '#999999',
        rating: '#FFD700',
    },
    spacing: {
        xs: 4,
        sm: 8,
        md: 12,
        lg: 16,
        xl: 20,
    },
    borderRadius: {
        sm: 4,
        md: 8,
        lg: 12,
    },
    fontSize: {
        sm: 12,
        md: 14,
        lg: 16,
        xl: 18,
    },
    shadow: {
        light: {
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.1,
            shadowRadius: 4,
            elevation: 3,
        },
    },
};
// Utility functions for component logic
const getMoviePosterUrl = (posterPath, size = 'w500') => {
    return posterPath ? `https://image.tmdb.org/t/p/${size}${posterPath}` : null;
};
exports.getMoviePosterUrl = getMoviePosterUrl;
const getMovieYear = (releaseDate) => {
    return releaseDate ? new Date(releaseDate).getFullYear() : null;
};
exports.getMovieYear = getMovieYear;
const formatMovieRating = (rating) => {
    return rating ? rating.toFixed(1) : '0.0';
};
exports.formatMovieRating = formatMovieRating;
